import {Button, Modal} from "antd";
import {useEffect, useState} from "react";
import OTPInput from "react-otp-input";
import styled from "styled-components";
import {useRegenerateBackupCodes} from "../../../react-query-hooks/two-factor";
import {StyledOtpInput} from "../../payouts/v2/tabs/payout-settings-tab/otp-view/styles";
import {RecoveryCodesContent} from "./RecoveryCodesModal";

const StyledRegenerateOtpInput = styled(StyledOtpInput)`
  && {
    flex: 1 1 0;
    width: 100% !important;
    min-width: 0;
    height: 6.4rem !important;
    border-radius: 10px;
  }
`;

type TRegenerateCodesStep = "verify" | "codes";

interface RegenerateCodesModalProps {
  visible: boolean;
  onClose: () => void;
}

export function RegenerateCodesModal({visible, onClose}: RegenerateCodesModalProps) {
  const [step, setStep] = useState<TRegenerateCodesStep>("verify");
  const [otp, setOtp] = useState("");
  const [newCodes, setNewCodes] = useState<string[]>([]);

  const regenerateMutation = useRegenerateBackupCodes();

  useEffect(() => {
    if (visible) {
      setStep("verify");
      setOtp("");
    }
  }, [visible]);

  const handleVerify = () => {
    regenerateMutation.mutate(
      {twofaCode: otp},
      {
        onSuccess: (response: any) => {
          setNewCodes(response.data.backupCodes);
          setStep("codes");
        },
        onError: () => setOtp(""),
      }
    );
  };

  const handleDone = () => {
    setStep("verify");
    setOtp("");
    onClose();
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      closable
      centered
      width={520}
      bodyStyle={{padding: 16}}
    >
      {step === "verify" && (
        <>
          <h2 style={{fontSize: "2rem", fontWeight: 600, marginBottom: "0.4rem"}}>
            Enter your authenticator code
          </h2>
          <p style={{marginBottom: "1.6rem"}}>
            To generate new recovery codes, enter the current code from your authenticator
            app
          </p>
          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            shouldAutoFocus
            inputType="tel"
            containerStyle={{display: "flex", gap: "12px", width: "100%"}}
            renderInput={(props) => <StyledRegenerateOtpInput {...props} />}
          />
          <div style={{display: "flex", gap: "12px", width: "100%", marginTop: "16px"}}>
            <Button size="small" style={{flex: 1}} onClick={onClose}>
              Cancel
            </Button>
            <Button
              size="small"
              style={{flex: 1}}
              type="primary"
              disabled={otp.length < 6}
              loading={regenerateMutation.isLoading}
              onClick={handleVerify}
            >
              Verify code
            </Button>
          </div>
        </>
      )}
      {step === "codes" && <RecoveryCodesContent codes={newCodes} onDone={handleDone} />}
    </Modal>
  );
}
